import { AppRoutes } from '../../lib/constants/routes'

export const showAIAssistantsNavItem = (
	path: string,
	hasAcceptedLatestTerms: boolean
): boolean => {
	if (
		(path === AppRoutes.TERMS_AND_CONDITIONS && !hasAcceptedLatestTerms) ||
		path === AppRoutes.ERROR_AUTHENTICATION ||
		path === AppRoutes.AUTH_SIGNIN
	) {
		return false
	}
	return true
}
